<mat-form-field class="autocomplete-container" appearance="outline">
	<app-icon [name]="'search-normal-1'" matPrefix style="padding-right: 10px"></app-icon>
	<input type="text" [placeholder]="label" matInput [formControl]="searchControl" [matAutocomplete]="auto" />
	<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" (optionSelected)="onOptionSelected($event)">
		@if ((filteredOptions$ | async); as items) { @for (option of items; track option.id) {
		<mat-option [value]="option">
			<strong>{{ displayWith(option) }}</strong>
		</mat-option>
		} } @if ((filteredOptions$ | async)?.length === 0) {
		<mat-option style="font-style: italic">0 results found</mat-option>
		}
	</mat-autocomplete>
	<mat-progress-spinner *ngIf="isLoading" mode="indeterminate" diameter="20" matSuffix></mat-progress-spinner>
</mat-form-field>
